import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { EditIcon, DeleteIcon } from 'foundations-assets';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CurrentlyScheduledCardInfo = ({
  actionTypeBodyInfoKey,
  dateTimeCopyOptions,
  onReschedulingClick,
  openCancelScheduleConfirmModal
}) => {
  const currentlyScheduledInfo = useMemo(() => {
    switch (actionTypeBodyInfoKey) {
      case 'scheduleUnpublish':
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "baseSchedulingOptionsModal.body.currentlyScheduledInfo.scheduleUnpublish",
          options: dateTimeCopyOptions
        });
      case 'scheduleUpdate':
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "baseSchedulingOptionsModal.body.currentlyScheduledInfo.scheduleUpdate",
          options: dateTimeCopyOptions
        });
      default:
        return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "baseSchedulingOptionsModal.body.currentlyScheduledInfo.schedulePublish",
          options: dateTimeCopyOptions
        });
    }
  }, [actionTypeBodyInfoKey, dateTimeCopyOptions]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(MultiColumn, {
      flush: true,
      children: /*#__PURE__*/_jsxs(MultiColumnGroup, {
        children: [/*#__PURE__*/_jsx(MultiColumnItem, {
          horizontalAlign: "left",
          verticalAlign: "middle",
          paddingInline: "200",
          children: currentlyScheduledInfo
        }), /*#__PURE__*/_jsx(MultiColumnItem, {
          horizontalAlign: "right",
          verticalAlign: "middle",
          paddingInline: "200",
          children: /*#__PURE__*/_jsx(IconButton, {
            use: "unstyled",
            onClick: onReschedulingClick,
            children: /*#__PURE__*/_jsx(EditIcon, {
              color: "do-not-use-eerie"
            })
          })
        }), /*#__PURE__*/_jsx(MultiColumnItem, {
          horizontalAlign: "right",
          verticalAlign: "middle",
          paddingInline: "200",
          children: /*#__PURE__*/_jsx(IconButton, {
            use: "unstyled",
            onClick: () => openCancelScheduleConfirmModal(actionTypeBodyInfoKey),
            children: /*#__PURE__*/_jsx(DeleteIcon, {
              color: "do-not-use-eerie"
            })
          })
        })]
      })
    })
  });
};
export default CurrentlyScheduledCardInfo;